/**
 * PRIVATE ROUTE SEGMENTS — single source of truth.
 *
 * Private app surfaces (dashboard, admin, auth, profile) where no floating
 * public UI should appear. Shared by the floating Start Now / WhatsApp stack
 * (src/components/FloatingActions.tsx) and the GoHighLevel chat launcher gate
 * (src/components/ChatWidgetGate.tsx) so the two lists can never drift apart.
 */
export const PRIVATE_SEGMENTS = [
  'dashboard',
  'panel',
  'admin',
  'administrador',
  'login',
  'iniciar-sesion',
  'register',
  'registro',
  'profile',
  'perfil',
  'reset-password',
  'restablecer-contrasena',
];

/** Strip the /en or /es prefix and return the remaining segments. */
export const segmentsOf = (pathname: string): string[] =>
  pathname.replace(/^\/(en|es)(?=\/|$)/, '').split('/').filter(Boolean);

/** True when the path's first segment (after /en|/es) is a private surface. */
export const isPrivatePath = (pathname: string): boolean => {
  const segs = segmentsOf(pathname);
  return segs.length > 0 && PRIVATE_SEGMENTS.includes(segs[0]);
};
